import { render } from "./AF.vue?vue&type=template&id=50b5c660"
import script from "./AF.vue?vue&type=script&lang=js"
export * from "./AF.vue?vue&type=script&lang=js"

import "./AF.vue?vue&type=style&index=0&id=50b5c660&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__